import { DatePicker, Form } from 'antd';
import dayjs from 'dayjs';
import React, { CSSProperties } from 'react';
import { Control, Controller as ControllerHookForm } from 'react-hook-form';

import { toFieldStatus } from 'src/app/utils/toFieldStatus';

interface DatePickerControllerProps {
  control: Control<any>;
  name: string;
  placeholder?: string;
  defaultValue?: string | Date;
  autoComplete?: string;
  onChange?: () => void;
  prefix?: React.ReactNode;
  type?: string;
  label?: string;
  format?: string;
  showTime?: boolean;
  disabled?: boolean;
  disableDate?: (currentDate: dayjs.Dayjs) => boolean;
  style?: CSSProperties;
  required?: boolean;
}

export const DatePickerController: React.FC<DatePickerControllerProps> = ({
  control,
  defaultValue,
  name,
  label,
  placeholder,
  format,
  showTime,
  disabled,
  disableDate,
  style,
  required,
}) => {
  return (
    <ControllerHookForm
      control={control}
      name={name}
      defaultValue={defaultValue}
      render={props => {
        const { status, help } = toFieldStatus(props.fieldState.error);

        return (
          <Form.Item
            label={label}
            validateStatus={status}
            help={help}
            required={required}
          >
            <DatePicker
              aria-label={label}
              placeholder={placeholder}
              style={{ width: '100%', ...style }}
              onChange={date => {
                // Enviar o objeto dayjs completo para o form
                props.field.onChange(date);
              }}
              onBlur={props.field.onBlur}
              data-testid={name}
              showTime={showTime}
              format={format ?? 'DD/MM/YYYY'}
              disabledDate={disableDate}
              value={props.field.value ? dayjs(props.field.value) : null}
              disabled={disabled}
            />
          </Form.Item>
        );
      }}
    />
  );
};
